var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomationStackCaseStudy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 410",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1L8 5L2 9",
    fill: "none",
    stroke: "context-stroke",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "imagine-text-gaps-td2si3",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 410,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.89276123046875,
    y: 22.611099243164062,
    width: 74.2144775390625,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 55.69442367553711,
    width: 194.99281311035156,
    height: 29.50002670288086,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 87.36109161376953,
    width: 239.2341766357422,
    height: 22.416685104370117,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.20200729370117,
    y: 134.61109924316406,
    width: 67.59598159790039,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.89645004272461,
    y: 150.5555419921875,
    width: 74.20709991455078,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.51125717163086,
    y: 186.61109924316406,
    width: 60.97748565673828,
    height: 16.75175666809082,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.886028289794922,
    y: 202.5555419921875,
    width: 80.22794342041016,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.1610107421875,
    y: 141.66665649414062,
    width: 29.677974700927734,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.88604736328125,
    y: 159.5555419921875,
    width: 80.22794342041016,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.8584747314453,
    y: 175.5555419921875,
    width: 98.2830810546875,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.8584747314453,
    y: 191.5555419921875,
    width: 98.2830810546875,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.88604736328125,
    y: 206.5555419921875,
    width: 80.22794342041016,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.27056884765625,
    y: 131.61109924316406,
    width: 87.45884704589844,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.8033142089844,
    y: 147.5555419921875,
    width: 134.39336395263672,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.27056884765625,
    y: 183.61109924316406,
    width: 87.45884704589844,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.8204650878906,
    y: 199.5555419921875,
    width: 122.35906219482422,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.2019958496094,
    y: 219.611083984375,
    width: 67.59598159790039,
    height: 16.75175666809082,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.8480529785156,
    y: 235.55555725097656,
    width: 104.30391693115234,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.64837646484375,
    y: 132.61109924316406,
    width: 100.7032241821289,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.8688659667969,
    y: 147.5555419921875,
    width: 92.26223754882812,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.3391418457031,
    y: 184.61109924316406,
    width: 107.32171630859375,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.85845947265625,
    y: 199.5555419921875,
    width: 98.2830810546875,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.2019958496094,
    y: 220.611083984375,
    width: 67.59598159790039,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.83087158203125,
    y: 235.55555725097656,
    width: 116.33821868896484,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.93748092651367,
    y: 279.58331298828125,
    width: 44.125038146972656,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.86888122558594,
    y: 304.5555419921875,
    width: 92.26223754882812,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.97914123535156,
    y: 279.58331298828125,
    width: 20.04167938232422,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.8584442138672,
    y: 304.5555419921875,
    width: 98.2830810546875,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.9374694824219,
    y: 279.58331298828125,
    width: 44.125038146972656,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.83087158203125,
    y: 304.5555419921875,
    width: 116.33821868896484,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.9166259765625,
    y: 279.58331298828125,
    width: 56.166717529296875,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.8479919433594,
    y: 304.5555419921875,
    width: 104.30391693115234,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.06488037109375,
    y: 336.611083984375,
    width: 27.87024688720703,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7556381225586,
    y: 336.611083984375,
    width: 34.48874282836914,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.89276123046875,
    y: 336.611083984375,
    width: 74.2144775390625,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.27056884765625,
    y: 336.611083984375,
    width: 87.45884704589844,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.27056884765625,
    y: 336.611083984375,
    width: 87.45884704589844,
    height: 16.751771926879883,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.9576416015625,
    y: 336.611083984375,
    width: 94.08472442626953,
    height: 16.751771926879883,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.51123046875,
    y: 336.611083984375,
    width: 60.97748565673828,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 372.611083984375,
    width: 511.2270812988281,
    height: 16.751771926879883,
    fill: "black",
    rx: 2
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 400,
    rx: 12,
    fill: "#080c14",
    style: {
      fill: "rgb(8, 12, 20)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 680,
    y2: 80,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 160,
    x2: 680,
    y2: 160,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 240,
    x2: 680,
    y2: 240,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 320,
    x2: 680,
    y2: 320,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 400,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 0,
    x2: 340,
    y2: 400,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 510,
    y1: 0,
    x2: 510,
    y2: 400,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 100,
    height: 22,
    rx: 4,
    fill: "#0a1a10",
    style: {
      fill: "rgb(10, 26, 16)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 35,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#00cc66",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 204, 102)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "AUTOMATION"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 78,
    fontSize: 22,
    fill: "#ffffff",
    fontWeight: 600,
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 22,
      fontWeight: 600,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Automation Stack"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 104,
    fontSize: 16,
    fill: "#6366f1",
    fontWeight: 500,
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 16,
      fontWeight: 500,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "End-to-End Pipeline Architecture"), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 130,
    width: 96,
    height: 40,
    rx: 5,
    fill: "#0d1020",
    stroke: "#6366f1",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(13, 16, 32)",
      stroke: "rgb(99, 102, 241)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 147,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#a5b4fc",
    fontFamily: "monospace",
    style: {
      fill: "rgb(165, 180, 252)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Lead form"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 162,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#4a4d8a",
    fontFamily: "monospace",
    style: {
      fill: "rgb(74, 77, 138)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "web capture"), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 182,
    width: 96,
    height: 40,
    rx: 5,
    fill: "#0d1020",
    stroke: "#6366f1",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(13, 16, 32)",
      stroke: "rgb(99, 102, 241)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 199,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#a5b4fc",
    fontFamily: "monospace",
    style: {
      fill: "rgb(165, 180, 252)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Telegram"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 214,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#4a4d8a",
    fontFamily: "monospace",
    style: {
      fill: "rgb(74, 77, 138)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "inbound msgs"), /*#__PURE__*/React.createElement("line", {
    x1: 122,
    y1: 150,
    x2: 158,
    y2: 170,
    stroke: "#6366f1",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(99, 102, 241)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122,
    y1: 202,
    x2: 158,
    y2: 186,
    stroke: "#6366f1",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(99, 102, 241)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 130,
    width: 120,
    height: 92,
    rx: 6,
    fill: "#0d0f1f",
    stroke: "#6366f1",
    strokeWidth: 1.2,
    style: {
      fill: "rgb(13, 15, 31)",
      stroke: "rgb(99, 102, 241)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.2px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 155,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#c7d2fe",
    fontFamily: "monospace",
    style: {
      fill: "rgb(199, 210, 254)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "n8n"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 171,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#6366f1",
    fontFamily: "monospace",
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "orchestrator"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 187,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#4a4d8a",
    fontFamily: "monospace",
    style: {
      fill: "rgb(74, 77, 138)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "route \xB7 trigger"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 203,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#4a4d8a",
    fontFamily: "monospace",
    style: {
      fill: "rgb(74, 77, 138)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "transform \xB7 log"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 218,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#3a3d6a",
    fontFamily: "monospace",
    style: {
      fill: "rgb(58, 61, 106)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "+ Claude API"), /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 155,
    x2: 318,
    y2: 148,
    stroke: "#2dd4bf",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(45, 212, 191)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 176,
    x2: 318,
    y2: 190,
    stroke: "#f59e0b",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(245, 158, 11)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 200,
    x2: 318,
    y2: 228,
    stroke: "#00cc66",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 204, 102)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 126,
    width: 110,
    height: 44,
    rx: 5,
    fill: "#001a18",
    stroke: "#2dd4bf",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 26, 24)",
      stroke: "rgb(45, 212, 191)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 144,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#2dd4bf",
    fontFamily: "monospace",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "CRM pipeline"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 159,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#0d6b60",
    fontFamily: "monospace",
    style: {
      fill: "rgb(13, 107, 96)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "nurture \xB7 score \xB7 tag"), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 178,
    width: 110,
    height: 44,
    rx: 5,
    fill: "#1a1400",
    stroke: "#f59e0b",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(26, 20, 0)",
      stroke: "rgb(245, 158, 11)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 196,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#f59e0b",
    fontFamily: "monospace",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Content pipe"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 211,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7a5c00",
    fontFamily: "monospace",
    style: {
      fill: "rgb(122, 92, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "LinkedIn \xB7 Telegram"), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 214,
    width: 110,
    height: 44,
    rx: 5,
    fill: "#001408",
    stroke: "#00cc66",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 20, 8)",
      stroke: "rgb(0, 204, 102)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 232,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#00cc66",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 204, 102)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Reporting"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 247,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#006630",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 102, 48)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "metrics \xB7 alerts"), /*#__PURE__*/React.createElement("line", {
    x1: 432,
    y1: 148,
    x2: 468,
    y2: 148,
    stroke: "#2dd4bf",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(45, 212, 191)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432,
    y1: 200,
    x2: 468,
    y2: 200,
    stroke: "#f59e0b",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    mask: "url(#imagine-text-gaps-td2si3)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(245, 158, 11)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432,
    y1: 236,
    x2: 468,
    y2: 236,
    stroke: "#00cc66",
    strokeWidth: 1,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 204, 102)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 130,
    width: 116,
    height: 36,
    rx: 5,
    fill: "#001a18",
    stroke: "#2dd4bf",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(0, 26, 24)",
      stroke: "rgb(45, 212, 191)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 528,
    y: 145,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#2dd4bf",
    fontFamily: "monospace",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Email sequence"), /*#__PURE__*/React.createElement("text", {
    x: 528,
    y: 159,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#0d6b60",
    fontFamily: "monospace",
    style: {
      fill: "rgb(13, 107, 96)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "auto-triggered"), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 182,
    width: 116,
    height: 36,
    rx: 5,
    fill: "#1a1400",
    stroke: "#f59e0b",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(26, 20, 0)",
      stroke: "rgb(245, 158, 11)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 528,
    y: 197,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#f59e0b",
    fontFamily: "monospace",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Scheduled posts"), /*#__PURE__*/React.createElement("text", {
    x: 528,
    y: 211,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7a5c00",
    fontFamily: "monospace",
    style: {
      fill: "rgb(122, 92, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "queue \xB7 publish"), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 218,
    width: 116,
    height: 36,
    rx: 5,
    fill: "#001408",
    stroke: "#00cc66",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(0, 20, 8)",
      stroke: "rgb(0, 204, 102)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 528,
    y: 233,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#00cc66",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 204, 102)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Dashboard"), /*#__PURE__*/React.createElement("text", {
    x: 528,
    y: 247,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#006630",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 102, 48)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "live pipeline view"), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 272,
    x2: 656,
    y2: 272,
    stroke: "#0f1520",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(15, 21, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 300,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#6366f1",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "80%"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 316,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#4a4d8a",
    fontFamily: "monospace",
    style: {
      fill: "rgb(74, 77, 138)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "ops time saved"), /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 300,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#2dd4bf",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 316,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#0d6b60",
    fontFamily: "monospace",
    style: {
      fill: "rgb(13, 107, 96)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "missed handoffs"), /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 300,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#f59e0b",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "6\u21921"), /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 316,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7a5c00",
    fontFamily: "monospace",
    style: {
      fill: "rgb(122, 92, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "tools consolidated"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 300,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#00cc66",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 204, 102)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "24/7"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 316,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#006630",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 102, 48)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "runs without you"), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 334,
    width: 48,
    height: 22,
    rx: 4,
    fill: "#0d1020",
    style: {
      fill: "rgb(13, 16, 32)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#6366f1",
    fontFamily: "monospace",
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "n8n"), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 334,
    width: 60,
    height: 22,
    rx: 4,
    fill: "#0d1020",
    style: {
      fill: "rgb(13, 16, 32)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#6366f1",
    fontFamily: "monospace",
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Make"), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 334,
    width: 90,
    height: 22,
    rx: 4,
    fill: "#001a18",
    style: {
      fill: "rgb(0, 26, 24)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 193,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#2dd4bf",
    fontFamily: "monospace",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Claude API"), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 334,
    width: 100,
    height: 22,
    rx: 4,
    fill: "#001a18",
    style: {
      fill: "rgb(0, 26, 24)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 296,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#2dd4bf",
    fontFamily: "monospace",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "LinkedIn API"), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 334,
    width: 100,
    height: 22,
    rx: 4,
    fill: "#001408",
    style: {
      fill: "rgb(0, 20, 8)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 404,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#00cc66",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 204, 102)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Telegram Bot"), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 334,
    width: 80,
    height: 22,
    rx: 4,
    fill: "#1a1400",
    style: {
      fill: "rgb(26, 20, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 502,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#f59e0b",
    fontFamily: "monospace",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Google Sheets"), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 334,
    width: 70,
    height: 22,
    rx: 4,
    fill: "#1a1400",
    style: {
      fill: "rgb(26, 20, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 585,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#f59e0b",
    fontFamily: "monospace",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Webhooks"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 385,
    fontSize: 11,
    fill: "#1a2030",
    fontFamily: "monospace",
    style: {
      fill: "rgb(26, 32, 48)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "automation pipeline \xB7 crm \xB7 content \xB7 reporting \xB7 multi-tool \xB7 no-code + api"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationStackCaseStudy);
export default __webpack_public_path__ + "static/media/automation-stack-case-study.f559cc5d6e3477675da84fcf0e80313d.svg";
export { ForwardRef as ReactComponent };